import React from 'react';
import PropTypes from 'prop-types';

/**
 * Band heading for each of the three planes. The tick carries the plane colour.
 *
 * `aside` is a status word ("2 need setup") in the plane's accent; `action` is
 * a control. They are separate props because the download button must not
 * inherit the accent colour — an accented icon reads as a warning next to a
 * "needs setup" count sitting right beside it.
 */
const PlaneHeader = ({ label, note, accent, aside, action }) => (
  <div className="flex items-baseline gap-[10px] flex-wrap mb-3">
    <span
      aria-hidden="true"
      className="w-[3px] h-[15px] rounded-sm translate-y-[2px]"
      style={{ backgroundColor: accent }}
    />
    <span className="text-base font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
      {label}
    </span>
    {note ? <span className="text-xs text-shoorah-gray3">{note}</span> : null}
    {aside ? (
      <span className="ml-auto text-xs font-medium" style={{ color: accent }}>
        {aside}
      </span>
    ) : null}
    {action ? <span className={aside ? 'ml-2' : 'ml-auto'}>{action}</span> : null}
  </div>
);

PlaneHeader.propTypes = {
  label: PropTypes.string.isRequired,
  note: PropTypes.string,
  accent: PropTypes.string.isRequired,
  aside: PropTypes.node,
  action: PropTypes.node
};

export default PlaneHeader;
